import React from "react";

const Return = () => {
  return (
    <>
    <div className="container">
      <div className="row pt-5">
        <div className="col-md-12">
          <h1>List of Return Order will appear here</h1>
        </div>
      </div>
    </div>
    </>
  );
};

export default Return;
